import { render, staticRenderFns } from "./HeatmapExample.vue?vue&type=template&id=17744f01&"
import script from "./HeatmapExample.vue?vue&type=script&lang=js&"
export * from "./HeatmapExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports